var VouchersListView = (function (BaseView, GetPageTemplate, CheckoutSettings) {

    var VoucherView = BaseView.extend({
        className: 'gift-voucher-coupon__small',

        events: {
            'click': '_apply'
        },

        initialize: function() {
            _.bindAll(this, '_render', '_apply', '_remove');
            this.listenTo(this.model, 'remove', this._remove);
            this.listenTo(this.model, 'change', this._render);
            this._render();
        },

        _render: function() {
            this.$el.html($.tmpl('bt-checkout-voucher-item', this.model.toJSON()));
            this.$el.toggleClass('gift-voucher-coupon__small-applied', this.model.get('IsApplied') === true);
        },

        _apply: function() {
            var _this = this;
            this.model.apply().done(function() {
                _this.display('checkout');
            });
        },

        _remove: function() {
            this.remove();
        }
    });

    return BaseView.extend({

        hiddenBlock: 'hidden-block',

        el: '@vouchersContainer',

        initialize: function() {
            _.bindAll(this, '_render', '_update');
            this.listenTo(this.collection, 'add', this._render);
            this.listenTo(this.collection, 'update', this._update);
        },

        _render: function(model) {
            var voucher = new VoucherView({ model: model });
            this.$el.append(voucher.$el);
        },

        _update: function() {
            this.$el.toggleClass(this.hiddenBlock, !this.collection.length);
        }
    });
})(BaseView, kos.getPageTemplate, CheckoutSettings);
